import React from 'react';
import { DropzoneArea } from 'material-ui-dropzone';
import { useTypedTranslation } from '@app/hooks';

interface IProps {
    handleChange: (file: any) => void;
}

export const PasslyDropzoneAreaComponent = ({ handleChange }: IProps) => {
    const { translation } = useTypedTranslation();

    const maxFileSize = 28400000;

    return (
        <div className='passlyDropzoneArea'>
            <DropzoneArea
                onChange={handleChange}
                acceptedFiles={['application/x-zip-compressed', 'application/zip']}
                showPreviews={false}
                maxFileSize={maxFileSize}
                dropzoneText={translation('DRAG_FILE')}
                showAlerts={true}
                filesLimit={1}
                showFileNames={true}
            />
        </div>
    );
};
